// extracted by mini-css-extract-plugin
export default {"container":"Games_container__t+4yE","section":"Games_section__ItBnJ","heading":"Games_heading__rml3l","line":"Games_line__Nbf7O","games":"Games_games__FA4M+"};